<template>
  <LinkWrapper :href="option?.betslipUrl" target="_blank" @click="handleClick">
    <DynamicText
      tag="span"
      styleGroup="Promo Text"
      :get="promoTextStyle.get"
      :set="promoTextStyle.set"
      class="odds-text"
      :class="classes.oddsText"
      >{{ odds }}
    </DynamicText>
  </LinkWrapper>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import DynamicText from "../../DynamicText.vue";
import LinkWrapper from "../../LinkWrapper.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { Option } from "@fresh8/types/src/betData";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { formatOdds } from "@fresh8/ad-data-composition/src/lib/formatOdds";
import { Brand } from "@fresh8/types/src";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";

const useStyles = createUseStyles({
  oddsText: {
    fontSize: "21px"
  }
});

export default defineComponent({
  components: {
    DynamicText,
    LinkWrapper
  },
  props: {
    option: { type: Object as PropType<Option>, required: true },
    marketId: { type: String, required: true }
  },
  setup(props) {
    const { adTemplate } = injectBrand();
    const cardNumber = injectCardNumber();
    const { handleClick } = useAnalytics(
      {
        marketId: props.marketId,
        optionId: props.option.id,
        cardNumber: cardNumber
      },
      "Odds Button"
    );
    const odds = computed(
      () =>
        (props.option &&
          formatOdds(
            props.option.odds,
            adTemplate.value.market.oddsButtonTemplate
          )) ||
        "-"
    );
    return {
      handleClick,
      classes: useStyles(),
      odds,
      promoTextStyle: {
        get(brand: Brand | undefined) {
          return brand && brand.adTemplate.market.promoTextFont;
        },
        set(brand: Brand, value: string) {
          brand.adTemplate.market.promoTextFont = value;
        }
      }
    };
  }
});
</script>
